import React, { ReactElement } from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import { Translations } from './configuration';
import { Button, Grid, Typography } from '@material-ui/core';
import { SchemeTypes } from '../../../../config';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch } from 'react-redux';
import ModalActions from '../../../../redux/reducers/gl_modal_reducer/actions';
import PreviousUseOfSpecialSchemeTable from './components/datatable';
interface IProps {
  mode: 'VIEW' | 'EDIT';
  scheme_type?: SchemeTypes;
  is_agent?: boolean;
  isExcluded: boolean;
}

export default function PreviousUseOfSpecialSchemes(
  props: IProps
): ReactElement {
  // console.log('Render PreviousUseOfSpecialSchemes');
  const mode = props.mode;
  const isExcluded = props.isExcluded;
  const dispatch = useDispatch();
  const openModal = (modal_id: number, params = {}) => {
    dispatch(
      ModalActions.openModalAction({
        modalID: modal_id,
        params: params,
      })
    );
  };

  return (
    <div>
      <Grid container>
        <Grid item sm={6} xs={12}>
          <Typography variant="h5">
            <TranslatedText textMap={Translations.previous_use_header} />
          </Typography>
        </Grid>
        <Grid item sm={6} xs={12} style={{ textAlign: 'right' }}>
          <Button
            type="button"
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() =>
              openModal(ModalIDs.MODAL_PREVIOUS_USE_OF_SPECIAL_SCHEMES)
            }
            disabled={mode === 'VIEW' || isExcluded}
          >
            <TranslatedText textMap={Translations.add_header_button} />
          </Button>
        </Grid>
      </Grid>
      <p>
        <TranslatedText textMap={Translations.subtitle} />
      </p>
      <PreviousUseOfSpecialSchemeTable mode={props.mode} />
    </div>
  );
}
